/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HelpdeskSyncJobsPathParameters } from 'api/actions/helpdesk-sync-jobs/helpdesk-sync-jobs-path-parameters';
import { HelpdeskSyncJobsResponse } from 'api/actions/helpdesk-sync-jobs/helpdesk-sync-jobs-response';

type HelpdeskSyncJobsQueryParameters = Record<string, any>;

/**
 * The path of the HelpdeskSyncJobs action.
 */
export const helpdeskSyncJobsActionPath = new SweetPath<keyof HelpdeskSyncJobsPathParameters>('/help-desk/jobs/sync', {
  path: '{param}',
});

/**
 * Creates a contextualized HelpdeskSyncJobs actions.
 */
export default function createHelpdeskSyncJobsAction(axios: AxiosInstance) {
  return function helpdeskSyncJobsAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: HelpdeskSyncJobsQueryParameters } = {}) {
    const path = helpdeskSyncJobsActionPath.original;

    return axios.get<HelpdeskSyncJobsResponse, HelpdeskSyncJobsResponse>(path, { params: query, headers });
  };
}
